import { ActiveSpecialPromotions,Cart } from 'modules/cart'
import { Promotion } from 'modules/products'

export const deliveryPromotionKeyword = 'dostawa'

export const checkIfPromotionIsActive = (
  promotion: Promotion,
  cart: Cart | null,
  activeSpecialPromotions?: ActiveSpecialPromotions[]
) => {
  if (promotion.type.includes('dostawa')) {
    return cart?.isEligibleForFreeDelivery
  } else
    return activeSpecialPromotions?.some(
      promo => promo.promotionId === promotion.id && promo.status === 'active'
    )
}

export const promotionStatusResolver = (
  promotion: Promotion,
  activeSpecialPromotion?: ActiveSpecialPromotions
) => {
  switch (activeSpecialPromotion?.status) {
    case 'active':
      return {
        remainedQuantity: promotion.minProductsQuantity
          ? promotion.minProductsQuantity *
            (Number(activeSpecialPromotion.activePromotionsQuantity) +
              1 -
              Number(activeSpecialPromotion.quantity))
          : null,
        remainedValue: promotion.minProductsValue
          ? promotion.minProductsValue *
              Number(activeSpecialPromotion.activePromotionsQuantity) +
            1 -
            Number(activeSpecialPromotion.quantity) -
            Number(activeSpecialPromotion.valueGross) / 100
          : null,
        activePromotionsQuantity:
          activeSpecialPromotion.activePromotionsQuantity
      }
    case 'pending':
      return {
        remainedQuantity: promotion.minProductsQuantity
          ? promotion.minProductsQuantity -
            Number(activeSpecialPromotion.quantity)
          : null,
        remainedValue: promotion.minProductsValue
          ? promotion.minProductsValue -
            Number(activeSpecialPromotion.valueGross) / 100
          : null,
        activePromotionsQuantity:
          activeSpecialPromotion.activePromotionsQuantity
      }
    default:
      return null
  }
}
